// Renderiza conteúdo dentro do slot da sidebar do AppShell.
// Permite que cada página injete sua lista de projetos / ações na sidebar
// persistente, sem que a sidebar inteira remonte ao navegar.
import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export const SIDEBAR_SLOT_ID = 'sidebar-slot';

export const SidebarPortal: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [el, setEl] = useState<HTMLElement | null>(null);
  useEffect(() => {
    setEl(document.getElementById(SIDEBAR_SLOT_ID));
  }, []);
  return el ? createPortal(children, el) : null;
};
